import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import SteelRoofPage from './pages/SteelRoofPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-white text-slate-900 font-sans selection:bg-[#d92323] selection:text-white">
        <Header />
        <main className="flex-grow">
          <Routes>
            {/* Primary Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/staaltag" element={<SteelRoofPage />} />
            <Route path="/ydelser" element={<ServicesPage />} />
            <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />
            <Route path="/projekter" element={<ProjectsPage />} />
            <Route path="/projekter/:slug" element={<ProjectDetailPage />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />

            {/* Scraped Legacy URL Redirects */}
            <Route path="/staaltage-i-vejle-og-hedensted" element={<Navigate to="/staaltag" replace />} />
            <Route path="/staaltage-i-vejle-og-hedensted/" element={<Navigate to="/staaltag" replace />} />
            <Route path="/metrotile-og-decra-tag" element={<Navigate to="/ydelser/metrotile-og-decra-tag" replace />} />
            <Route path="/metrotile-og-decra-tag/" element={<Navigate to="/ydelser/metrotile-og-decra-tag" replace />} />
            <Route path="/tagrenovering" element={<Navigate to="/ydelser/tagrenovering" replace />} />
            <Route path="/tagrenovering/" element={<Navigate to="/ydelser/tagrenovering" replace />} />
            <Route path="/doere-og-vinduer" element={<Navigate to="/ydelser/doere-og-vinduer" replace />} />
            <Route path="/doere-og-vinduer/" element={<Navigate to="/ydelser/doere-og-vinduer" replace />} />
            <Route path="/tilbygning-og-ombygning" element={<Navigate to="/ydelser/tilbygning-og-ombygning" replace />} />
            <Route path="/tilbygning-og-ombygning/" element={<Navigate to="/ydelser/tilbygning-og-ombygning" replace />} />
            <Route path="/totalrenovering" element={<Navigate to="/ydelser/totalrenovering" replace />} />
            <Route path="/totalrenovering/" element={<Navigate to="/ydelser/totalrenovering" replace />} />
            <Route path="/referencer" element={<Navigate to="/projekter" replace />} />
            <Route path="/referencer/" element={<Navigate to="/projekter" replace />} />

            {/* Individual Scraped Projects Legacy Redirects */}
            <Route path="/nyt-tag-jyllandsgade-i-horsens" element={<Navigate to="/projekter/nyt-tag-jyllandsgade-i-horsens" replace />} />
            <Route path="/nyt-tag-jyllandsgade-i-horsens/" element={<Navigate to="/projekter/nyt-tag-jyllandsgade-i-horsens" replace />} />
            <Route path="/nyt-staal-tag-paa-klintevej-vejle" element={<Navigate to="/projekter/nyt-staal-tag-paa-klintevej-vejle" replace />} />
            <Route path="/nyt-staal-tag-paa-klintevej-vejle/" element={<Navigate to="/projekter/nyt-staal-tag-paa-klintevej-vejle" replace />} />
            <Route path="/ny-trappe-til-baghave-i-rask-moelle" element={<Navigate to="/projekter/ny-trappe-til-baghave-i-rask-moelle" replace />} />
            <Route path="/ny-trappe-til-baghave-i-rask-moelle/" element={<Navigate to="/projekter/ny-trappe-til-baghave-i-rask-moelle" replace />} />
            <Route path="/ny-lade-vaerksted-i-lindved" element={<Navigate to="/projekter/ny-lade-vaerksted-i-lindved" replace />} />
            <Route path="/ny-lade-vaerksted-i-lindved/" element={<Navigate to="/projekter/ny-lade-vaerksted-i-lindved" replace />} />

            {/* Status Code Pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
